export const notesColumns = [
    {
        key: 'Date',
        title: 'Date',
        formatter: value => {
            const date = new Date(value);
            return !isNaN(date.getTime())
                ? date.toLocaleString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true,
                })
                : 'Invalid Date';
        },
    },
    {
        key: 'Note',
        title: 'Note',
    },
    {
        key: 'SK',
        title: 'Note ID',
    },
    {
        key: 'action',
        title: 'Action',
        isAction: true,
    },
];
